export const INVALID_CREDENTIALS = 'The email and/or password are incorrect.'
export const TOO_MANY_ATTEMPTS = 'Too many attempts. Please wait and try again.'
export const ALREADY_REQUESTED = 'You have already requested to join this organization.'
export const ALREADY_A_MEMBER = 'You are already a member.'
export const REMOVED_FROM_ORG = 'You have been removed from this organization.'
export const SUSPENDED = 'Your account has been suspended.'
export const FORBIDDEN = '403 - Forbidden'
export const NO_RESPONSE = 'No Response From Server'
export const NOT_FOUND = '404 - Not Found'
export const WHOOPS = '500 - Something went wrong'
export const IMAGE_REQUIRED = 'You must supply an image.'



// WEBPACK FOOTER //
// ./src/error-messages/index.js